import React, { useState } from 'react'
import { VerticalTimeline } from 'react-vertical-timeline-component'
import 'react-vertical-timeline-component/style.min.css'
// import './style.scss'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/image.css'
import { TimelineElement } from 'components/timelineElement'
import { Menu } from 'components/menu'

export const Timeline = ({ promises }) => {
  const [activeYear, setActiveYear] = useState()

  return (
    <>
      <Menu activeYear={activeYear} entries={promises} />
      <div id='timeline'>
        <VerticalTimeline layout='2-columns' animate={false}>
          {promises.map((value, index) => {
            return (
              <TimelineElement
                key={value.idx}
                idx={value.idx}
                imgId={value.imageId}
                year={value.year}
                name={value.name}
                role={value.role}
                promise={value.promise}
                source={value.source}
                subheader={value.subheader}
                reality={value.reality}
                setActiveYear={setActiveYear}
              />
            )
          })}
        </VerticalTimeline>
      </div>
    </>
  )
}
